module.exports = __webpack_public_path__ + "resources/img/ico_check.1b7a23753a35883289e20558478c4efc.png";